module.exports = __webpack_public_path__ + "static/media/our-story-two.58a27146.jpg";